import React from "react"

export default function({ handleButtonClick, paymentDetail, isRefunded }) {
  return (
    <div className="payment space-between">
      <div>
        <span className="bold">Proof of Payment</span>
        <span>
          (Bank deposit slip, Fund transfer screenshots, Payment slips, etc.)
        </span>
      </div>
      <span>
        <button type="button" onClick={handleButtonClick}>
          {(((paymentDetail && paymentDetail.state === "For Verification") ||
            isRefunded) &&
            "View") ||
            "Upload"}
        </button>
      </span>
    </div>
  )
}
